import type { Components, Theme } from "@mui/material";

export const accordionDetailsTheme: Components<Theme>["MuiAccordionDetails"] = {
  styleOverrides: {
    root: {
      padding: "16px",
    },
  },
};
